import { StatCardComponent } from '@components/shared/statistics-cards/stat-card.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LogService } from '@services/util/log.service';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { DashboardDataService, TodaysMetrics } from '../../services/dashboard-data.service';

@Component({
  selector: 'app-todays-metrics',
  imports: [CommonModule, TranslateModule, StatCardComponent],
  templateUrl: './todays-metrics.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TodaysMetricsComponent implements OnInit {
  private readonly dashboardDataService = inject(DashboardDataService);
  private readonly translateService = inject(TranslateService);

  // Signals for reactive state management
  protected readonly isLoading = signal(true);
  protected readonly metrics = signal<TodaysMetrics | null>(null);
  protected readonly error = signal<string | null>(null);
  protected readonly log = inject(LogService);

  ngOnInit() {
    this.loadTodaysMetrics();
  }

  protected loadTodaysMetrics() {
    this.isLoading.set(true);
    this.error.set(null);

    this.dashboardDataService.getTodaysMetrics().subscribe({
      next: (metrics) => {
        this.metrics.set(metrics);
        this.isLoading.set(false);
      },
      error: (error) => {
        this.log.error("Error loading today's metrics:", error);
        this.error.set(this.translateService.instant('dashboard.todaysMetrics.error'));
        this.isLoading.set(false);
      }
    });
  }

  // Helper methods for template
  protected getCheckinDisplay(): string {
    const metrics = this.metrics();
    if (!metrics) return '0/0';
    return `${metrics.checkins.completed}/${metrics.checkins.total}`;
  }

  protected getCheckoutDisplay(): string {
    const metrics = this.metrics();
    if (!metrics) return '0/0';
    return `${metrics.checkouts.completed}/${metrics.checkouts.total}`;
  }

  protected getCleaningDisplay(): string {
    const metrics = this.metrics();
    if (!metrics) return '0/0';
    return `${metrics.cleaning.completed}/${metrics.cleaning.total}`;
  }

  protected getExpediaDisplay(): string {
    const metrics = this.metrics();
    if (!metrics) return '0';
    return metrics.expedia.toString();
  }
}
